"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var schemas_1 = require("@dcl/schemas");
var react_1 = __importDefault(require("react"));
var NotificationItemNFTLink = function (_a) {
    var link = _a.link, rarity = _a.rarity, name = _a.name;
    return (react_1.default.createElement("a", { href: link, style: {
            color: "".concat(schemas_1.Rarity.getColor(rarity)),
            textDecoration: 'underline'
        } }, name));
};
exports.default = NotificationItemNFTLink;
